export const throwIfString = (
  val: any,
  blockId?: string
): Exclude<typeof val, string> => {
  if (typeof val !== "string") return val;
  throw new Error(
    `expected field not to be a string${blockId ? `block id: ${blockId}` : ""}`
  );
};
